import React from "react";
import AuthFormCard from "components/auth-form-card/AuthFormCard";
import AuthForm from "components/auth-form/AuthForm";
import ErrorModal from "modals/error-modal/ErrorModal";
import SuccessModal from "modals/success-modal/SuccessModal";
import LoadingModalV1 from "modals/loading/LoadingModalV1";
import { useForgotPassword } from "./useForgotPassword";

/**
 * Forgot-password form. The server mails a temporary password, so this app's only job is to ask
 * for the address and hand it over.
 *
 * Merchants sign in with an email or a merchant ID, so unlike the cardholder app the address is
 * something they already know.
 */
function ForgotPasswordForm() {
  const {
    fields,
    submitRef,
    isSubmitDisabled,
    showLoading,
    loadingMsg,
    showError,
    errorMsg,
    showSuccess,
    successMsg,
    handleSubmit,
    handleCloseError,
    handleCloseSuccess,
    handleBackToLogin,
  } = useForgotPassword();

  return (
    <>
      <AuthFormCard
        title="Reset your password"
        subtitle="We'll email you a temporary password to sign in with."
      >
        <AuthForm
          fields={fields}
          submitLabel="Send temporary password"
          onSubmit={handleSubmit}
          disabled={isSubmitDisabled}
          isLoading={showLoading}
          submitRef={submitRef}
        />

        <p className="v1-auth-nav">
          Remembered it?{" "}
          <button
            className="v1-auth-nav-link"
            type="button"
            onClick={handleBackToLogin}
          >
            Back to sign in
          </button>
        </p>
      </AuthFormCard>

      <LoadingModalV1 isOpen={showLoading} loadingMsg={loadingMsg} />

      {/* No tryAgain: the form is still filled in behind this, and the retry is the form itself. */}
      <ErrorModal
        isOpen={showError}
        errorMsg={errorMsg}
        handleClose={handleCloseError}
      />

      <SuccessModal
        isOpen={showSuccess}
        message={successMsg}
        handleClose={handleCloseSuccess}
      />
    </>
  );
}

export default ForgotPasswordForm;
